import styled from 'styled-components';

import media from 'styled-media-query';

const Container = styled.div`
	margin-left: auto;
	margin-right: auto;
	padding: 0 1rem;
    width: 100%;

	${media.greaterThan('medium')`
		max-width: 1400px;
	`}
`;

export default Container;